import types from "../types";

const initialState = [];

function ordersReducer(state = initialState, { type, payload }) {
  switch (type) {
    case types.STORE_ORDERS:
      return payload;

    case types.EDIT_ORDER:
      return state.map((order) => {
        if (order.id === payload.order.id)
          return { ...order, status: payload.status };
        return order;
      });

    default:
      return state;
  }
}

export default ordersReducer;
